
document.querySelectorAll('.ApartmentItemList__sort .SelectBase, .ApartmentsListFilter .SelectBase, .AgenciesList__sort .SelectBase').forEach((el) => {
    SelectBaseInit(el);
})

function SelectBaseInit(el) {
    checkInit(el,() => {
        return new SelectBase(el, undefined, el.dataset.multiple);
    });
}
